import React from "react";
import { connect } from "react-redux";
import { Card, Header, Icon, Segment } from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import { isPermit } from "./permission";
class MainPage extends React.Component {
  state = { showModal: false, modalInput: "", width: 0 };
  componentWillReceiveProps() {
    this.forceUpdate();
    this.setJob();
  }
  componentDidMount() {
    this.setJob();
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }
  setJob = () => {
    this.setState({ job: localStorage.getItem("type") });
  };

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }
  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth });
  };
  goTo = page => {
    const { history } = this.props;
    history.push(page);
    this.setState({ visible: false });
  };

  render() {
    return (
      <div className="main-page__container">
        <div className="main-page__items-container">
          <Segment placeholder>
            <Header>
              <Card.Group
                itemsPerRow={this.state.width < 768 ? 16 : 6}
                className="rtl padded"
              >
                {isPermit("sale", this.state.job) ? (
                  <Card
                    raised
                    className="p-5 pointer tale"
                    onClick={() => {
                      this.goTo("/sale/");
                    }}
                  >
                    <Icon
                      size="huge"
                      className="m-auto w-100"
                      name="money bill alternate"
                    />
                    <h2 className="text-black yekan text-center">فروش</h2>
                  </Card>
                ) : null}

                {isPermit("cashregister", this.state.job) ? (
                  <Card
                    raised
                    className="p-5 pointer tale"
                    onClick={() => {
                      this.goTo("/cashregister/");
                    }}
                  >
                    <Icon size="huge" className="m-auto w-100" name="fax" />
                    <h2 className="text-black yekan text-center">صندوق</h2>
                  </Card>
                ) : null}

                {isPermit("depository", this.state.job) ? (
                  <Card
                    raised
                    className="p-5 pointer tale"
                    onClick={() => {
                      this.goTo("/depository/");
                    }}
                  >
                    <Icon size="huge" className="m-auto w-100" name="factory" />
                    <h2 className="text-black yekan text-center">انبارداری</h2>
                  </Card>
                ) : null}
                {isPermit("reports", this.state.job) ? (
                  <Card
                    raised
                    className="p-5 pointer tale"
                    onClick={() => {
                      this.goTo("/reports/");
                    }}
                  >
                    <Icon
                      size="huge"
                      className="m-auto w-100"
                      name="chart pie"
                    />
                    <h2 className="text-black yekan text-center">گزارشات</h2>
                  </Card>
                ) : null}

                {isPermit("customers", this.state.job) ? (
                  <Card
                    raised
                    className="p-5 pointer tale"
                    onClick={() => {
                      this.goTo("/customers/");
                    }}
                  >
                    <Icon size="huge" className="m-auto w-100" name="users" />
                    <h2 className="text-black yekan text-center">مشتریان</h2>
                  </Card>
                ) : null}

                {isPermit("suppliers", this.state.job) ? (
                  <Card
                    raised
                    className="p-5 pointer tale"
                    onClick={() => {
                      this.goTo("/suppliers/");
                    }}
                  >
                    <Icon size="huge" className="m-auto w-100" name="truck" />
                    <h2 className="text-black yekan text-center">
                      تامین کنندگان
                    </h2>
                  </Card>
                ) : null}
              </Card.Group>
            </Header>
          </Segment>
        </div>
      </div>
    );
  }
}


export default connect(null, null)(withRouter(MainPage));
